import { isAxiosError } from 'axios';

export async function normalizeBlobError(error: unknown): Promise<void> {
  if (!isAxiosError<unknown>(error) || !error.response || typeof Blob === 'undefined') {
    return;
  }

  const data = error.response.data;
  if (!(data instanceof Blob) || !/^application\/(?:json|[\w.+-]+\+json)(?:\s*;|$)/i.test(data.type)) {
    return;
  }

  try {
    // Download requests use responseType: blob even when the server returns a JSON error.
    const parsed: unknown = JSON.parse(await data.text());
    // Only the API error envelope: message helpers map over `errors`, so any other
    // JSON would turn a readable Blob failure into a crash in the error handler.
    if (isApiErrorEnvelope(parsed)) {
      error.response.data = parsed;
    }
  } catch {
    // Preserve the original HTTP failure if its body cannot be decoded.
  }
}

const isApiErrorEnvelope = (value: unknown): value is { errors: { code: string }[] } =>
  value !== null &&
  typeof value === 'object' &&
  'errors' in value &&
  Array.isArray(value.errors) &&
  value.errors.every(
    (entry: unknown) => entry !== null && typeof entry === 'object' && 'code' in entry && typeof entry.code === 'string'
  );
